import React from 'react';
import Route from 'react-router/lib/Route';

import AddPromoCode from '../settings/promoCodes/Add';
import EditPromoCode from '../settings/promoCodes/Edit';
import BrandUserDiscountsWrapper from '../wrappers/brandUserDiscountsWrapper';
import { brandPromosRedirectByPermissionCheck } from '../../auth/routerHooks';

const BrandRoutes = store => (
  <Route
    path="discounts" name="discounts"
    onEnter={brandPromosRedirectByPermissionCheck(store)}
  >
    <Route
      path="promo/add"
      name="discounts.promoCodes.add"
      component={AddPromoCode}
    />
    <Route
      path="promo/:id/edit"
      name="discounts.promoCodes.edit"
      component={EditPromoCode}
    />
    <Route
      path=":page"
      component={BrandUserDiscountsWrapper}
      name="discounts.details"
    />
  </Route>
);

export default {
  BrandRoutes,
};
